import React, { useEffect } from "react";
import { CheckCircle, Home, Phone, Mail } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const ThankYouPage = () => {
  useEffect(() => {
    // Scroll to top on page load
    window.scrollTo(0, 0);
    
    // Optional: Analytics tracking event
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        'send_to': 'CONVERSION_ID', // À remplacer par l'ID réel
        'event_category': 'Contact',
        'event_label': 'Form Submission'
      });
    }
    
    // Optional: Facebook Pixel tracking
    if (window.fbq) {
      window.fbq('track', 'Lead');
    }
  }, []);

  const goHome = () => {
    window.location.href = '/';
  };

  return (
    <div className="min-h-screen bg-[#FAF9F6]">
      <Header />
      
      {/* Conversion Tracking Element */}
      <div id="conversion-tracking" className="conversion-success" style={{display: 'none'}}>
        {/* Conversion tag ready */}
      </div>
      
      <main role="main" className="section-padding">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          {/* Icon de succès */}
          <div className="mb-8">
            <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <CheckCircle size={48} className="text-green-600" />
            </div>
            
            {/* Titre principal */}
            <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-[#1C3A27] mb-6">
              Merci pour votre demande 🌿
            </h1>
            
            {/* Message de confirmation */}
            <p className="text-lg md:text-xl text-[#1C3A27]/80 max-w-2xl mx-auto leading-relaxed mb-8">
              Votre message a bien été transmis à Nathalie et Wilhelm. Ils reviendront vers vous rapidement pour confirmer les disponibilités.
            </p>
          </div>

          {/* Informations de suivi */}
          <div className="bg-white rounded-2xl p-6 md:p-8 shadow-lg border border-[#EDE6DB]/50 mb-8 max-w-2xl mx-auto">
            <h2 className="font-serif text-xl md:text-2xl font-bold text-[#1C3A27] mb-4">
              Que se passe-t-il maintenant ?
            </h2>
            <div className="space-y-4 text-left">
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-[#1C3A27]/10 rounded-full flex items-center justify-center mt-0.5 flex-shrink-0">
                  <span className="text-[#1C3A27] text-sm font-bold">1</span>
                </div>
                <p className="text-[#1C3A27]/80">
                  Nous étudions votre demande et vos dates souhaitées
                </p>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-[#1C3A27]/10 rounded-full flex items-center justify-center mt-0.5 flex-shrink-0">
                  <span className="text-[#1C3A27] text-sm font-bold">2</span>
                </div>
                <p className="text-[#1C3A27]/80">
                  Nathalie & Wilhelm vous contactent sous 24h
                </p>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-[#1C3A27]/10 rounded-full flex items-center justify-center mt-0.5 flex-shrink-0">
                  <span className="text-[#1C3A27] text-sm font-bold">3</span>
                </div>
                <p className="text-[#1C3A27]/80">
                  Nous finalisons ensemble les détails de votre séjour
                </p>
              </div>
            </div>
          </div>

          {/* Contact d'urgence */}
          <div className="bg-[#EDE6DB]/30 rounded-2xl p-6 md:p-8 mb-8 max-w-2xl mx-auto">
            <h3 className="font-serif text-lg md:text-xl font-bold text-[#1C3A27] mb-4">
              Besoin d'une réponse immédiate ?
            </h3>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:+33664104815"
                className="btn-primary bg-green-600 hover:bg-green-700 px-6 py-3 transition-colors"
                aria-label="Appeler directement - 06 64 10 48 15"
              >
                <Phone size={20} className="flex-shrink-0" />
                <span className="ml-2">📞 06 64 10 48 15</span>
              </a>
              <a
                href="mailto:wilhelm.martel@orange.fr"
                className="btn-secondary px-6 py-3 hover:bg-[#1C3A27] hover:text-white transition-colors"
                aria-label="Envoyer un email"
              >
                <Mail size={20} className="flex-shrink-0" />
                <span className="ml-2">Nous écrire</span>
              </a>
            </div>
          </div>

          {/* Bouton retour à l'accueil */}
          <button
            onClick={goHome}
            className="btn-primary text-base md:text-lg px-6 md:px-8 py-3 md:py-4 hover:bg-[#2A5236] transition-colors transform hover:scale-105"
            aria-label="Revenir à l'accueil"
          >
            <Home size={20} className="flex-shrink-0" />
            <span className="ml-2">Retourner au gîte</span>
          </button>

          {/* Message de réassurance */}
          <div className="mt-8 text-sm text-[#1C3A27]/60">
            <p>Vos données sont traitées avec la plus grande confidentialité.</p>
            <p className="mt-1">
              Gîte Cœurs de Normands - 31 Rue Notre-Dame, 14570 Clécy
            </p>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default ThankYouPage;